import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import api, { formatError } from "@/lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); toast.success("Ako korisnik postoji, poslan je reset link"); }
    catch (err) { toast.error(formatError(err)); }
    setBusy(false);
  };
  return (
    <div className="stream-dark min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><Logo light /></Link>
        <div className="card-dark p-8">
          <h1 className="font-heading font-black text-3xl text-white mb-2">Reset lozinke</h1>
          {sent ? (
            <p className="text-white/70">Ako korisnik postoji, kreiran je reset link. Za MVP: link je zapisan u backend log.</p>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-4">
              <div>
                <Label className="text-white/80">Email</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2 bg-white/5 border-white/10 text-white h-11 rounded-xl" data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={busy} className="btn-yellow w-full h-12 rounded-xl" data-testid="forgot-submit">Pošalji reset link</Button>
            </form>
          )}
          <Link to="/login" className="block mt-6 text-center text-sm text-white/60 hover:text-[#FFD60A]">Nazad na prijavu</Link>
        </div>
      </div>
    </div>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/reset-password", { token, password }); toast.success("Lozinka promijenjena"); nav("/login"); }
    catch (err) { toast.error(formatError(err)); }
    setBusy(false);
  };
  return (
    <div className="stream-dark min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><Logo light /></Link>
        <div className="card-dark p-8">
          <h1 className="font-heading font-black text-3xl text-white mb-6">Nova lozinka</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-white/80">Nova lozinka</Label>
              <Input type="password" value={password} onChange={(e) => setPwd(e.target.value)} required minLength={6} className="mt-2 bg-white/5 border-white/10 text-white h-11 rounded-xl" data-testid="reset-password" />
            </div>
            <Button type="submit" disabled={busy} className="btn-yellow w-full h-12 rounded-xl" data-testid="reset-submit">Postavi lozinku</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
